<template>
  <div class="pa-8 text-md-center">
    <div class="d-flex align-center justify-center mb-4">
      <v-icon color="grey-lighten-1" :icon="icon" size="64" />
    </div>
    {{ text || $t('COMMON.NO_DATA') }}
  </div>
</template>

<script>
export default {
  name: 'EmptyListState',
  props: {
    icon: {
      type: String,
      default: 'mdi-database-off-outline'
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
